<template>
  <div class="home">
    <section class="home-sub-banner">
      <div class="jp-line"></div>
      <div class="jp-column">
        <!-- <img :src="homeSubBanner" alt="" class="w-100"> -->
        <div class="sub-banner-content">
          <!-- <img :src="logo" alt="" class="logo"> -->
          <div class="sub-banner-title">
            <p>{{$t('home.subTitle1')}}</p>
            <p class="special">{{$t('home.subTitle2')}}</p>
          </div>
          <img :src="subBannerBj" alt="" class="sub-banner-bj">
        </div>
      </div>
    </section>

    <el-carousel trigger="click" :height="bannerHeigth" :interval="7000" class="hidden-xs-only">
      <el-carousel-item v-for="img in banner" :key="img.id">
        <a :href="img.hyperlinks">
          <el-image :src="img.imageUrl" class="w-100"></el-image>
        </a>
      </el-carousel-item>
    </el-carousel>
    <swiper ref="mySwiper" :options="swiperOptions" class="hidden-sm-and-up" v-if='banner.length>0'>
      <swiper-slide v-for="(img, index) in banner" :index="index" :key="img.id">
        <img :src="img.imageUrl" class="w-100" v-if="img.imageUrl" />
      </swiper-slide>
      <!-- 分页器 -->
      <div class="swiper-pagination" v-for="img in banner" :key="img.id" slot="pagination"></div>
    </swiper>

    <section class="jp-grey-bg">
      <div class="jp-line"></div>
      <div class="jp-column mt-5">
        <span class="title jp-grey-bg">
          <div class="jp-line-withit"></div>
          <span class="title-name">{{$t('home.business')}}</span>
        </span>
        <span class="en-common-title">Business Domain</span>
        <!-- <div class="text-right mb-2"><small class="jp-more" @click="moreNews"><i class="el-icon-arrow-right"></i> {{$t('common.more')}}</small></div> -->
        <el-row>
          <el-col :span="12" :xs="24">
            <el-row :type="rowType" :gutter="12" class="jp-project-content">
              <el-col :span="6">
                <img :src="bussinessImg1" alt="" class="w-100">
              </el-col>
              <el-col :span="18" :xs="24" class="mb-3">
                <div class="card-content">
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="24" class="text-left">
                      <!-- <div class="jp-line-blue"></div> -->
                      <h3>{{$t('business.technology')}}</h3>
                      <h3 class="en-title">Technology cooperation</h3>
                    </el-col>
                  </el-row>
                  <div class="card-text">
                    <p>{{$t('business.technologyContent')}}</p>
                    <p class="en-content">Aim towards upgrades in products and in the current Chinese market and share the market with local enterprises through collaboration technology.</p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-row :type="rowType" :gutter="12" class="jp-project-content">
              <el-col :span="6">
                <img :src="bussinessImg2" alt="" class="w-100">
              </el-col>
              <el-col :span="18" :xs="24" class="mb-3">
                <div class="card-content">
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="24" class="text-left">
                      <!-- <div class="jp-line-blue"></div> -->
                      <h3>{{$t('business.joint')}}</h3>
                      <h3 class="en-title">Joint development</h3>
                    </el-col>
                  </el-row>
                  <div class="card-text">
                    <p>{{$t('business.jointContent')}}</p>
                    <p class="en-content">Collaborate with academic institutions and technological enterprises to share intellectual property rights and promote the commercialization of achievements. </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-row :type="rowType" :gutter="12" class="jp-project-content">
              <el-col :span="6">
                <img :src="bussinessImg3" alt="" class="w-100">
              </el-col>
              <el-col :span="18" :xs="24" class="mb-3">
                <div class="card-content">
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="14" class="text-left">
                      <!-- <div class="jp-line-blue"></div> -->
                      <h3>{{$t('business.independent')}}</h3>
                      <h3 class="en-title">Independent R&D</h3>
                    </el-col>
                  </el-row>
                  <div class="card-text">
                    <p>{{$t('business.independentContent')}}</p>
                    <p class="en-content">Focus on the market development trend, layout the next generation of products and technologies, and cultivate new technology and production processes. </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="12" :xs="24">
            <el-row :type="rowType" :gutter="12" class="jp-project-content">
              <el-col :span="6">
                <img :src="bussinessImg4" alt="" class="w-100">
              </el-col>
              <el-col :span="18" :xs="24" class="mb-3">
                <div class="card-content">
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="15" class="text-left">
                      <!-- <div class="jp-line-blue"></div> -->
                      <h3>{{$t('business.investment')}}</h3>
                      <h3 class="en-title">M&A</h3>
                    </el-col>
                  </el-row>
                  <div class="card-text">
                    <p>{{$t('business.investmentContent')}}</p>
                    <p  class="en-content">Investment activities in start-up companies in the advanced technology field. </p>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </section>
    <section class="jp-grey-bg" id="show-top2">
      <div class="jp-line"></div>
      <div class="jp-column mt-5">
        <div class="title">
          <!-- <span>{{$t('home.news')}}</span> -->
          <span>
            <div class="jp-line-withit"></div>
            <span class="title-name">{{$t('home.news')}}</span>
          </span>
          <span class="jp-more ml-3" @click="moreNews">
            <img :src="iconRight" class="icon-image">
            <span class="more-text">see more</span>
          </span>
        </div>
        <span class="en-common-title">Information Center</span>
        <div class="text-left jp-news">
          <el-row :gutter="12">
            <el-col :span="8" :xs="24" v-for="(news, index) in newsList" :key="index" 
            class="card-animation-two animated jp-news-card mb-2"
            style="animation-duration: 2s; animation-name: none;"
            :style="{ animationDelay: (index===0 ? '0s': index===1? '0.2s': '0.4s')}">
              <div @click="newsDetail(news.id)">
                <el-card :body-style="{ padding: '0px' }">
                  <div class="jp-overflow-hidden jp-news-list-img">
                    <img :src="news.thumbnail" class="image" />
                  </div>
                  <div class="jp-news-content">
                    <div class="jp-line-blue"></div>
                    <h3 class="mb-3">{{news.title}}</h3>
                    <div>
                      <p>{{news.newsBriefing}}</p>
                    </div>
                    <div class="bottom clearfix">
                      <time class="time">{{news.createTime}}</time>
                      <!-- <div class="text-right my-3 detail">{{$t('common.viewDetails')}} <img :src="iconRight" class="icon-image"></div> -->
                      <div class="text-right my-3 detail">
                        <span class="jp-more ml-3">
                          <img :src="iconRight" class="icon-image">
                          <span class="more-text">see more</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import _ from 'lodash';
import { getAllBanner, getNewsList } from '@/api/websiteApi';
import dateFormat from '@/filters/formatTime'

import logo from '@/assets/sub-logo.jpeg';
import subBannerBj from '@/assets/img/sub-banner-bj.png';
import iconRight from '@/assets/img/icon-right.svg';
import engineering1 from '@/assets/img/e1.svg';
import engineering2 from '@/assets/img/e2.svg';
import engineering3 from '@/assets/img/e3.svg';
import engineering4 from '@/assets/img/e4.svg';
import engineering5 from '@/assets/img/e5.svg';
import homeSubBanner from '@/assets/img/homeSubBanner.png';
import bussinessImg1 from '@/assets/img/bussinessImg1.jpg';
import bussinessImg2 from '@/assets/img/bussinessImg2.jpg';
import bussinessImg3 from '@/assets/img/bussinessImg3.jpg';
import bussinessImg4 from '@/assets/img/bussinessImg4.jpg';
export default {
  name: 'home',
  data () {
    return {
      timer: false,
      start: true,
      start1: true,
      start2: false,
      rowType: '',
      alignType: '',
      bannerHeigth: (document.body.clientWidth * 414 / 1354) + 'px',
      defaltBannerHeigth: (document.body.clientWidth * 414 / 1354) + 'px',
      iconRight: iconRight,
      logo: logo,
      subBannerBj: subBannerBj,
      engineering1: engineering1,
      engineering2: engineering2,
      engineering3: engineering3,
      engineering4: engineering4,
      engineering5: engineering5,
      homeSubBanner: homeSubBanner,
      bussinessImg1: bussinessImg1,
      bussinessImg2: bussinessImg2,
      bussinessImg3: bussinessImg3,
      bussinessImg4: bussinessImg4,
      banner: [],
      newsList: [],
      swiperOptions: {
        loop: true,
        loopFillGroupWithBlank: false,
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            // clickable: true,
            type: "bullets"
        }
      }
    }
  },
  watch: {
    '$i18n.locale'(val) {
      this.tabLang(val);
    }
  },
  destroyed(){
    window.removeEventListener("scroll",this.handleScroll);
  },
  mounted () {
    this.init();
    this.getWidth();
    setTimeout(() => {
      this.handleScroll();
    },700)
    window.onresize = () => {
      this.setBannerSize();
      this.getWidth();
    }
    window.addEventListener('scroll', this.handleScroll) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
  },
  methods: {
    init() {
      getAllBanner().then(res => {
        _.forEach(res, item => {
          item.imageUrl = item.imageUrl.split('..')[1];
          item.imageUrl = this.imageBaseUrl + item.imageUrl;
        });
        this.banner = res;
        this.setBannerSize();
      })
      getNewsList().then(res => {
        res = res.slice(0,3);
        _.forEach(res, item => {
          item.createTime = dateFormat.formatDate(new Date(item.createTime), 'yyyy-MM-dd')
          item.titleJa = item.titleJa.substr(0, 10) + '...';
          item.titleZh = item.titleZh.substr(0, 10) + '...';
          item.thumbnail = item.thumbnail.split('..')[1];
          item.thumbnail = this.imageBaseUrl + item.thumbnail;
        });
        this.newsList = res;
        this.tabLang(this.$i18n.locale)
        this.start2 = true;
        // setTimeout(() => {
        //   this.newsShow();
        // }, 100)
      })
    },
    getWidth() {
      let width = `${document.documentElement.clientWidth}`;
      if (width < 992) {
        this.rowType = ''
        this.alignType = ''
      } else {
        this.rowType = 'flex'
        this.alignType = 'bottom'
      }
    },
    setBannerSize() {
      if (this.banner[0]) {
        let img = new Image();
        img.src = this.banner[0].imageUrl;
        this.bannerHeigth = (document.body.clientWidth * img.height / img.width) + 'px';
        if (this.bannerHeigth > this.defaltBannerHeigth) {
          this.bannerHeigth = this.defaltBannerHeigth;
        }
      }
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      // document.getElementsByClassName('card-animation')[0].style.opacity = 1;
      // this.anamorphismShow(scrollTop);
      // this.gradShow(scrollTop);
      this.newsShow(scrollTop);
    },
    anamorphismShow(scrollTop) {
      if (document.getElementById('show-top')) {
        let showTopHeight = document.getElementById('show-top').offsetTop - scrollTop;
        if (showTopHeight < 600 && this.start) {
          document.getElementsByClassName('card-animation')[0].style.opacity = 1;
          this.start = false;
        }
      }
    },
    gradShow(scrollTop) {
      if (document.getElementById('show-top1')) {
        let showTopHeight = document.getElementById('show-top1').offsetTop - scrollTop;
        let domLenght = document.getElementsByClassName('card-animation-one').length;
        if (showTopHeight < 770 && this.start1) {
          for(let i=0; i< domLenght;i++) {
            document.getElementsByClassName('card-animation-one')[i].style.animationName = '';
            document.getElementsByClassName('card-animation-one')[i].style.visibility = 'visible';
          }
          this.start1 = false;
        }
      }
    },
    newsShow(scrollTop) {
      if (document.getElementById('show-top2')) {
        let showTopHeight = document.getElementById('show-top2').offsetTop - scrollTop;
        let domLenght = document.getElementsByClassName('card-animation-two').length;
        if (showTopHeight < 900 && this.start2) {
          for(let i=0; i< domLenght;i++) {
            document.getElementsByClassName('card-animation-two')[i].style.animationName = '';
            document.getElementsByClassName('card-animation-two')[i].style.visibility = 'visible';
          }
          this.start2 = false;
        }
      }
    },
    tabLang(val) {
      _.forEach(this.newsList, item => {
        if (val === 'cn') {
          item.title = item.titleZh;
          item.newsBriefing = item.newsBriefingZh.substr(0,50) + '...';
        }if (val === 'en') {
          item.title = item.titleEn;
          item.newsBriefing = item.newsBriefingEn.substr(0,50) + '...';
        }if (val === 'jp') {
          if (item.titleJa) {
            item.title = item.titleJa;
          }
          if (item.newsBriefingJa) {
            item.newsBriefing = item.newsBriefingJa.substr(0,50) + '...';
          }
        }
      });
    },
    setActiveNav (index, path, param) {
      this.$router.push({ name: path, params: { type: param }, query: { route: index } })
    },
    newsDetail(id) {
      this.$router.push({ name: 'new', params: { id: id } });
    },
    technologyDetail() {
      this.$router.push({ name: 'technology' });
    },
    projectDetail(type) {
      this.$router.push({ name: 'project', params: { type: type } });
    },
    moreNews() {
      this.$router.push({ name: 'newsList' });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/style/variables.scss';

section {
  h2 {
    font-size: 3rem;
  }
  .jp-project-content {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }

  .p-card {
    color: #fff;
    .jp-more {
      color: #fff;
    }
    .engineer-icon {
      width: 88px;
      margin: 0 auto;
    }
    p {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor:pointer;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
      font-size: 14px;
    }
  }

  .jp-project-content {
    font-size: 1.4rem;
    height: 300px;
    .animated {
      margin-bottom: 2.5rem;
    }
  }
  .news-hot {
    color: $white;
    background-color: #ff7413;
    border-radius: 4px;
    margin-left: 8px;
    padding: 0 2px;
  }
  .news-tip {
    color: $white;
    background-color: #ff455b;
    border-radius: 4px;
    margin-left: 8px;
    padding: 0 2px;
  }
  .jp-news {
    .detail:hover {
      color: $cardText;
      cursor: pointer;
    }
    p {
      font-size: 1rem;
      cursor: pointer;
      line-height: 30px;
    }
    p:hover {
      color: $cardText;
    }
  }
}

@media (max-width: 768px){
  section {
    .jp-project-content {
      font-size: 1.7rem;

      .el-image {
        max-height: 104px;
      }
    }
    .p-card {
      .engineer-icon {
        width: 74px;
      }
    }
    .engineer-content {
      h3 {
        margin-top: 35px;
        margin-left: 2rem;
      }
      p {
        padding-bottom: 1rem;
      }
      .w-121 {
        width: 126px !important;
        padding-left: 0;
      }
      .engineer-bg2 {
        .w-121 {
          width: 106px !important;
          padding-left: 0;
        }
      }
    }
    .project_en {
      .p-card {
        p {
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor:pointer;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          font-size: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home.vue